const roundels = [
  "korea",
  "korea_low",
  "us",
  "us_low",
  "us_white",
  "canada",
  "france",
  "france_navy",
  "uk",
  "german",
  "austria",
  "italy",
  "netherlands",
  "netherlands_low",
  "spain",
  "swiss",
  "sweden",
  "sweden_low",
  "greece",
  "japan",
  "singapore",
  "taiwan",
  "malaysia",
  "thailand",
  "north_korea",
  "china",
  "china_low",
  "soviet",
  "russia",
  "russia_low",
  "croatia",
  "czech",
  "poland",
  "romania",
  "hungary",
  "ukraine",
  "qatar",
  "india",
  "pakistan",
  "bangladesh",
  "turkey",
  "israel",
  "israel_low",
  "saudi",
  "iran",
  "iraq",
  "cuba",
  "brazil",
  "brazil_low",
  "brazil_navy",
  "peru",
  "peru_low",
  "peru_navy",
  "mexico",
  "mexico_low",
  "colombia",
  "colombia_low",
  "colombia_navy",
  "colombia_navy_low",
  "empty",
];

export default roundels;
